import { NgModule } from '@angular/core';

import { COWTUXSidebarComponent } from './sidebar.component';

@NgModule({
    declarations: [
        COWTUXSidebarComponent
    ],
    exports     : [
        COWTUXSidebarComponent
    ]
})
export class COWTUXSidebarModule
{
}
